import React from "react";
import { IValuesStore } from "@src/Stores/Values/types";
import _ from "lodash";
import { inject } from "mobx-react";
import { IManagementStore } from "@src/Stores/Management/types";
import { ISystemSettings } from "@src/Interfaces/Entity/SystemSettings";
import { IAuthStore } from "@src/Stores/Auth/types";
import ReplaceWithPrimaryButton from "./ReplaceWithPrimaryButton/ReplaceWithPrimaryButton";
import { STFormWrapper } from "./styles";
import RestoreDatabaseBackup from "./RestoreDatabaseBackup/RestoreDatabaseBackup";
import CreateDatabaseBackup from "./CreateDatabaseBackup/CreateDatabaseBackup";

interface IProps {
  initialValues: ISystemSettings;
  management?: IManagementStore;
  values?: IValuesStore;
  auth?: IAuthStore;
}

@inject("auth", "management", "values")
export default class DatabaseForm extends React.Component<IProps> {
  render() {
    return (
      <STFormWrapper>
        <RestoreDatabaseBackup />
        <CreateDatabaseBackup />
        {this.props.values.isInitialSynchronizationConfigured && <ReplaceWithPrimaryButton />}
      </STFormWrapper>
    );
  }
}
